import { render } from "./AccessCode.vue?vue&type=template&id=6535fc2e&scoped=true"
import script from "./AccessCode.vue?vue&type=script&lang=js"
export * from "./AccessCode.vue?vue&type=script&lang=js"

import "./AccessCode.vue?vue&type=style&index=0&id=6535fc2e&scoped=true&lang=scss"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6535fc2e"]])

export default __exports__